import React, { ReactNode, useEffect, useState } from 'react'
import Scorecards from './Scorecards';
import AutomatedQA from './AutomatedQA';
import { Drawer, DrawerContent, DrawerItem, DrawerItemProps, DrawerSelectEvent } from '@progress/kendo-react-layout';
import { Tooltip } from '@progress/kendo-react-tooltip';
import { Button } from '@progress/kendo-react-buttons';
import openPanel from '../../../assets/images/left-panel-close.svg';
import closePanel from '../../../assets/images/left-panel-open.svg';
import useTranslation from "../../../hooks/useTranslation";
import useLocale from "../../../hooks/useLocale";

interface INavItem {
  text?: string;
  icon?: string;
  selected?: boolean;
  content?: ReactNode;
  translateKey?: string;
}

const items: INavItem[] = [
  {
    text: "Evaluation Scorecard",
    icon: "bi bi-person",
    selected: false,
    content: <Scorecards />,
    translateKey: "EvaluationScorecard",
  },
  {
    text: "Auto QA",
    icon: "bi bi-shield-check",
    selected: true,
    content: <AutomatedQA />,
    translateKey: "AutoQA",
  },
];

function ScorecardManagement() {

  const [expanded, setExpanded] = useState<boolean>(true);
  const [navItems, setNavItems] = useState<INavItem[]>([]);
  const [selectedId, setSelectedId] = useState<number>(0);
  const trans = useTranslation("ScorecardManagement");
  const localeCtx = useLocale();

  useEffect(() => {
    if (
      !localeCtx?.selectedLocale?.current.componentTranslations["ScorecardManagement"]
    ) {
      trans.fetchTranslations("ScorecardManagement");
    }
  }, [localeCtx?.selectedLocale]);

  useEffect(() => {
    setNavItems(getTabItems());
  }, []);

  const getTabItems = () => {
    var _navItem = items
      .filter((item) => {
        return true;
      })
      .map((item, index) => {
        return {
          ...item,
          selected: index === selectedId,
        };
      });

    return _navItem;
  };

  const handleExpandChange = () => {
    setExpanded((prevState) => !prevState);
  };

  const handleSelectionChange = (event: DrawerSelectEvent) => {
    navItems.forEach((i, idx) => {
      if (idx === event.itemIndex) {
        i.selected = true;
      } else {
        i.selected = false;
      }
    });
    setSelectedId(event.itemIndex);
    setExpanded(true);
  };

  const CustomItem = (props: DrawerItemProps) => {
    return (
      <DrawerItem title={expanded ? trans.fetchLabelKeyTranslation(props.translateKey==="AutoQA" ? "ComingNextYear" : props.translateKey, props.text??"") : ""} {...props} className="scorecards">
        <span
          title={!expanded ? trans.fetchLabelKeyTranslation(props.translateKey==="AutoQA" ? "ComingNextYear" : props.translateKey, props.text??"") : ""}
          className={"k-icon " + props.icon}
        />
        <span className={"k-item-text"}>{trans.fetchLabelKeyTranslation(props.translateKey, props.text??props.translateKey)}</span>
      </DrawerItem>
    );
  };

  return (
    <div className='mainDrawerContainer'>
        <div className="mainDrawer navPushDown navPush">
          <div className="mainDrawerInner">
            <div className={`miniButton ${expanded ? 'drawer-expanded' : 'drawer-collapsed'}`}>
              <Button
                icon="menu"
                fillMode="flat"
                onClick={handleExpandChange}
              >
              <img
                    src={expanded ? openPanel : closePanel}
                    alt={expanded ? 'Close Side Panel' : 'Open Side Panel'}
                  />
              </Button>
            </div>
            <Drawer
              expanded={expanded}
              position="start"
              mode="push"
              width={230}
              mini={true}
              items={navItems.map((item: INavItem) => {
                return item;
              })}
              onSelect={handleSelectionChange}
              item={CustomItem}
            >
              <DrawerContent>
                <div className="contentPush">
                  {navItems.find((item) => item.selected === true)?.content}
                </div>
              </DrawerContent>
            </Drawer>
          </div>
        </div>
    </div>
  )
}

export default ScorecardManagement